import { render, staticRenderFns } from "./AuthGroupsScopesAdmin.vue?vue&type=template&id=ebe36a96&scoped=true"
import script from "./AuthGroupsScopesAdmin.vue?vue&type=script&lang=js"
export * from "./AuthGroupsScopesAdmin.vue?vue&type=script&lang=js"
import style0 from "./AuthGroupsScopesAdmin.vue?vue&type=style&index=0&id=ebe36a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe36a96",
  null
  
)

export default component.exports